import { render, staticRenderFns } from "./MinorCard.vue?vue&type=template&id=6502d44c&"
import script from "./MinorCard.vue?vue&type=script&lang=js&"
export * from "./MinorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports